import * as React from "react";
import { Navigate } from "react-router";
import type { FeatureNavModule, FeatureRouteModule } from "../types";
import { Clock, Shapes } from "lucide-react";
import { AutomationPage } from "@/pages/automation";
import { FlowEditorPage } from "@/pages/flow-editor";
import { FlowsPage } from "@/pages/flows";
import { SkillsPage } from "@/pages/skills";
import { StudioEvalsPage } from "@/pages/studio-evals";
import { StudioPage } from "@/pages/studio";
import { ToolsPage } from "@/pages/tools";

export const studioRoutes: FeatureRouteModule = {
  shellRoutes: [
    {
      path: "studio",
      handle: { title: "Studio" },
      element: React.createElement(StudioPage),
      children: [
        {
          index: true,
          element: React.createElement(Navigate, { to: "workflows", replace: true }),
        },
        {
          path: "workflows",
          handle: { title: "Workflows" },
          element: React.createElement(FlowsPage, { headingLevel: "h2" }),
        },
        {
          path: "skills",
          handle: { title: "Skills" },
          element: React.createElement(SkillsPage, { headingLevel: "h2" }),
        },
        {
          path: "tools",
          handle: { title: "Tools" },
          element: React.createElement(ToolsPage, { headingLevel: "h2" }),
        },
        {
          path: "evals",
          handle: { title: "Evals" },
          element: React.createElement(StudioEvalsPage, { headingLevel: "h2" }),
        },
      ],
    },
    {
      path: "flows",
      element: React.createElement(Navigate, { to: "/studio/workflows", replace: true }),
    },
    {
      path: "tools",
      element: React.createElement(Navigate, { to: "/studio/tools", replace: true }),
    },
    {
      path: "flows/:flowId/edit",
      handle: { title: "Flow editor" },
      element: React.createElement(FlowEditorPage),
    },
    {
      path: "automation",
      handle: { title: "Automation" },
      element: React.createElement(AutomationPage),
    },
  ],
  shellRouteDefs: [
    {
      path: "/studio",
      title: "Studio",
      summary: "Workflows, skills, tools, and evals for this project.",
    },
    {
      path: "/studio/workflows",
      title: "Workflows",
      summary: "The workflows this project can run.",
    },
    {
      path: "/studio/skills",
      title: "Skills",
      summary: "Skills installed in this project.",
    },
    {
      path: "/studio/tools",
      title: "Tools",
      summary: "Tools attached to this project.",
    },
    {
      path: "/studio/evals",
      title: "Evals",
      summary: "Eval suites for Studio content.",
    },
    {
      path: "/automation",
      title: "Automation",
      summary: "Runs that start on a schedule or an event.",
    },
  ],
};

export const studioNav: FeatureNavModule = {
  navGroups: [
    {
      label: "Build",
      items: [
        { to: "/studio", label: "Studio", icon: Shapes, end: false },
        { to: "/automation", label: "Automation", icon: Clock, end: false },
      ],
    },
  ],
};
